import { RouterModule, Routes } from '@angular/router';
// import { LoginComponent } from './login/login.component';
// import { ForgotPasswordComponent } from './forgot.password/forgot.password.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { PrivacyShortComponent } from './privacy-short/privacy-short.component';
import { BXBFooterComponent } from './bxb-footer/bxb-footer.component';
import { PrivacyFullComponent } from './privacy-full/privacy-full.component';
import { oLoginComponent } from './okta-login/okta-login.component';
import { RedirectComponent } from './okta-login/redirect.component';
import { OktaForgotPassword } from './okta-forgot-password/okta-forgot-password.component';
import { TenantComponent } from './tenant/tenant.component';
import { AccessDeniedComponent } from './shared/403/access.denied.component';
import { LogoutComponent } from './logout/logout.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import {
  OktaCallbackComponent
} from '@okta/okta-angular';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'implicit/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'login/redirect',
    component: RedirectComponent
  },
  // { path: 'login', component: LoginComponent },
  // { path: 'login/resetpassword', component: ForgotPasswordComponent },
  { path: 'login/terms-of-use', component: TermsOfUseComponent },
  { path: 'login/privacy-short', component: PrivacyShortComponent },
  { path: 'login/privacy-full', component: PrivacyFullComponent },
  { path: 'login/bxb-footer', component: BXBFooterComponent },
  { path: 'login/help', component: OktaForgotPassword },
  { path: 'login/forgotpassword', component: OktaForgotPassword },
  { path: 'login/tenant', component: TenantComponent },
  { path: 'login/sso', component: oLoginComponent },
  { path: 'login/access-denied', component: AccessDeniedComponent },
  { path: 'login/logout', component: LogoutComponent },
  { path: 'login/reset-password', component: ResetPasswordComponent },
  { path: 'login/:accountId', component: oLoginComponent },
  { path: 'login', component: oLoginComponent },
  { path: '**',  redirectTo: '/redirect' }
];

export const routing = RouterModule.forRoot(routes, { useHash: false });



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.routing.ts